import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Expenses from './pages/Expenses';
import Reports from './pages/Reports';
import AdSpend from './pages/AdSpend';
import Alerts from './pages/Alerts';
import Settings from './pages/Settings';
import Billing from './pages/Billing';

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/products" element={<Products />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/ad-spend" element={<AdSpend />} />
        <Route path="/alerts" element={<Alerts />} />
        {/* /integrations hidden until ad-platform credentials are configured. */}
        <Route path="/settings" element={<Settings />} />
        <Route path="/billing" element={<Billing />} />
      </Routes>
    </Layout>
  );
}
